import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';

@Metamodel.model({
    name: 'TriggerProperties',
    abstract: true
})
export abstract class TriggerProperties extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        constraint: {
            required: true
        }
    })
    public multiplePipelines: boolean = true;

}
